<ng-template [ngIf]="disabled">
    <input type="text" class="form-control" [value]="tipoFrete?.nome | uppercase" disabled="disabled" readonly="readonly">
</ng-template>

<ng-template [ngIf]="!disabled">
    <select 
        #select
        class="form-control" 
        [name]="name"
        [id]="id"
        [required]="required"
        [ngModel]="ngModel || ''" 
        (ngModelChange)="onChange($event ? $event : null)">
        <option value="" *ngIf="canSelectNull || (required && !ngModel)">
            {{nullLabel}}
        </option>
        <option *ngFor="let tipo of tipos" [ngValue]="tipo.id">{{tipo.nome | uppercase}}</option>
    </select>  
</ng-template>